// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/design-system.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Design System */

/* Global App Styles */
.App {
  min-height: 100vh;
  font-family: var(--font-family-sans);
  background: linear-gradient(135deg, var(--neutral-50) 0%, var(--primary-50) 100%);
  position: relative;
}

.App::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 80%, var(--primary-100) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, var(--secondary-100) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, var(--info-100) 0%, transparent 50%);
  opacity: 0.3;
  z-index: -1;
  pointer-events: none;
}

/* Enhanced Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, var(--neutral-50) 0%, var(--primary-50) 100%);
  position: relative;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--neutral-200);
  border-top: 4px solid var(--primary-600);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: var(--space-6);
  box-shadow: var(--shadow-lg);
}

.loading-spinner::after {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 2px solid var(--primary-200);
  border-radius: 50%;
  animation: spin 2s linear infinite reverse;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-container p {
  color: var(--neutral-600);
  font-size: var(--text-lg);
  font-weight: var(--font-medium);
  margin: 0;
  text-align: center;
  max-width: 300px;
  line-height: var(--leading-relaxed);
}

/* Enhanced Utility Classes */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Glass Morphism Effect */
.glass {
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: var(--shadow-xl);
}

.glass-dark {
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: var(--shadow-xl);
}

/* Enhanced Card Styles */
.card {
  background: white;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--neutral-200);
  transition: all var(--transition-normal);
  overflow: hidden;
}

.card:hover {
  box-shadow: var(--shadow-xl);
  transform: translateY(-2px);
}

.card-header {
  padding: var(--space-6);
  border-bottom: 1px solid var(--neutral-200);
  background: linear-gradient(135deg, var(--neutral-50) 0%, white 100%);
}

.card-body {
  padding: var(--space-6);
}

.card-footer {
  padding: var(--space-6);
  border-top: 1px solid var(--neutral-200);
  background: var(--neutral-50);
}

/* Enhanced Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-6);
  font-size: var(--text-base);
  font-weight: var(--font-medium);
  line-height: var(--leading-tight);
  border-radius: var(--radius-lg);
  border: 1px solid transparent;
  cursor: pointer;
  transition: all var(--transition-normal);
  text-decoration: none;
  position: relative;
  overflow: hidden;
  min-height: 48px;
  /* Elderly-friendly touch target */
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left var(--transition-slow);
}

.btn:hover::before {
  left: 100%;
}

.btn-primary {
  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-700) 100%);
  color: white;
  box-shadow: var(--shadow-md);
}

.btn-primary:hover {
  background: linear-gradient(135deg, var(--primary-700) 0%, var(--primary-800) 100%);
  box-shadow: var(--shadow-lg);
  transform: translateY(-1px);
}

.btn-secondary {
  background: linear-gradient(135deg, var(--secondary-600) 0%, var(--secondary-700) 100%);
  color: white;
  box-shadow: var(--shadow-md);
}

.btn-secondary:hover {
  background: linear-gradient(135deg, var(--secondary-700) 0%, var(--secondary-800) 100%);
  box-shadow: var(--shadow-lg);
  transform: translateY(-1px);
}

.btn-outline {
  background: transparent;
  color: var(--primary-600);
  border: 2px solid var(--primary-600);
}

.btn-outline:hover {
  background: var(--primary-600);
  color: white;
  transform: translateY(-1px);
}

.btn-ghost {
  background: transparent;
  color: var(--neutral-600);
  border: 1px solid var(--neutral-300);
}

.btn-ghost:hover {
  background: var(--neutral-100);
  color: var(--neutral-800);
}

.btn-lg {
  padding: var(--space-4) var(--space-8);
  font-size: var(--text-lg);
  min-height: 56px;
}

.btn-sm {
  padding: var(--space-2) var(--space-4);
  font-size: var(--text-sm);
  min-height: 40px;
}

/* Enhanced Form Styles */
/* Form Groups - Now using global styles from design-system.css */

.form-input::placeholder {
  color: var(--neutral-400);
}

/* Enhanced Alert Styles */
.alert {
  padding: var(--space-4);
  border-radius: var(--radius-lg);
  border: 1px solid;
  margin-bottom: var(--space-4);
  font-size: var(--text-base);
  font-weight: var(--font-medium);
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.alert-success {
  background: var(--success-50);
  border-color: var(--success-200);
  color: var(--success-800);
}

.alert-warning {
  background: var(--warning-50);
  border-color: var(--warning-200);
  color: var(--warning-800);
}

.alert-error {
  background: var(--error-50);
  border-color: var(--error-200);
  color: var(--error-800);
}

.alert-info {
  background: var(--info-50);
  border-color: var(--info-200);
  color: var(--info-800);
}

/* Enhanced Badge Styles */
.badge {
  display: inline-flex;
  align-items: center;
  padding: var(--space-1) var(--space-3);
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  border-radius: var(--radius-full);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.badge-primary {
  background: var(--primary-100);
  color: var(--primary-800);
}

.badge-secondary {
  background: var(--secondary-100);
  color: var(--secondary-800);
}

.badge-success {
  background: var(--success-100);
  color: var(--success-800);
}

.badge-warning {
  background: var(--warning-100);
  color: var(--warning-800);
}

.badge-error {
  background: var(--error-100);
  color: var(--error-800);
}

/* Enhanced Animation Classes */
.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

.slide-up {
  animation: slideUp 0.5s ease-out;
}

.scale-in {
  animation: scaleIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive Grid System */
.grid {
  display: grid;
  gap: var(--space-6);
}

.grid-cols-1 {
  grid-template-columns: repeat(1, 1fr);
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

@media (max-width: 768px) {

  .grid-cols-2,
  .grid-cols-3,
  .grid-cols-4 {
    grid-template-columns: 1fr;
  }
}

/* Flexbox Utilities */
.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.flex-row {
  flex-direction: row;
}

.items-center {
  align-items: center;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.gap-2 {
  gap: var(--space-2);
}

.gap-4 {
  gap: var(--space-4);
}

.gap-6 {
  gap: var(--space-6);
}

.gap-8 {
  gap: var(--space-8);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAGzB,sBAAsB;AACtB;EACE,iBAAiB;EACjB,oCAAoC;EACpC,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;2EAGyE;EACzE,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,qEAAqE;AACvE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mFAAmF;EACnF,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mFAAmF;EACnF,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,uFAAuF;EACvF,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,uFAAuF;EACvF,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB,iEAAiE;;AAEjE;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Import Design System */\n@import url('./styles/design-system.css');\n\n/* Global App Styles */\n.App {\n  min-height: 100vh;\n  font-family: var(--font-family-sans);\n  background: linear-gradient(135deg, var(--neutral-50) 0%, var(--primary-50) 100%);\n  position: relative;\n}\n\n.App::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background:\n    radial-gradient(circle at 20% 80%, var(--primary-100) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, var(--secondary-100) 0%, transparent 50%),\n    radial-gradient(circle at 40% 40%, var(--info-100) 0%, transparent 50%);\n  opacity: 0.3;\n  z-index: -1;\n  pointer-events: none;\n}\n\n/* Enhanced Loading Container */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, var(--neutral-50) 0%, var(--primary-50) 100%);\n  position: relative;\n}\n\n.loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--neutral-200);\n  border-top: 4px solid var(--primary-600);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: var(--space-6);\n  box-shadow: var(--shadow-lg);\n}\n\n.loading-spinner::after {\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  right: -4px;\n  bottom: -4px;\n  border: 2px solid var(--primary-200);\n  border-radius: 50%;\n  animation: spin 2s linear infinite reverse;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-container p {\n  color: var(--neutral-600);\n  font-size: var(--text-lg);\n  font-weight: var(--font-medium);\n  margin: 0;\n  text-align: center;\n  max-width: 300px;\n  line-height: var(--leading-relaxed);\n}\n\n/* Enhanced Utility Classes */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Glass Morphism Effect */\n.glass {\n  background: rgba(255, 255, 255, 0.25);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  box-shadow: var(--shadow-xl);\n}\n\n.glass-dark {\n  background: rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  box-shadow: var(--shadow-xl);\n}\n\n/* Enhanced Card Styles */\n.card {\n  background: white;\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--neutral-200);\n  transition: all var(--transition-normal);\n  overflow: hidden;\n}\n\n.card:hover {\n  box-shadow: var(--shadow-xl);\n  transform: translateY(-2px);\n}\n\n.card-header {\n  padding: var(--space-6);\n  border-bottom: 1px solid var(--neutral-200);\n  background: linear-gradient(135deg, var(--neutral-50) 0%, white 100%);\n}\n\n.card-body {\n  padding: var(--space-6);\n}\n\n.card-footer {\n  padding: var(--space-6);\n  border-top: 1px solid var(--neutral-200);\n  background: var(--neutral-50);\n}\n\n/* Enhanced Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: var(--space-3) var(--space-6);\n  font-size: var(--text-base);\n  font-weight: var(--font-medium);\n  line-height: var(--leading-tight);\n  border-radius: var(--radius-lg);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  text-decoration: none;\n  position: relative;\n  overflow: hidden;\n  min-height: 48px;\n  /* Elderly-friendly touch target */\n}\n\n.btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left var(--transition-slow);\n}\n\n.btn:hover::before {\n  left: 100%;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-700) 100%);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, var(--primary-700) 0%, var(--primary-800) 100%);\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-1px);\n}\n\n.btn-secondary {\n  background: linear-gradient(135deg, var(--secondary-600) 0%, var(--secondary-700) 100%);\n  color: white;\n  box-shadow: var(--shadow-md);\n}\n\n.btn-secondary:hover {\n  background: linear-gradient(135deg, var(--secondary-700) 0%, var(--secondary-800) 100%);\n  box-shadow: var(--shadow-lg);\n  transform: translateY(-1px);\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--primary-600);\n  border: 2px solid var(--primary-600);\n}\n\n.btn-outline:hover {\n  background: var(--primary-600);\n  color: white;\n  transform: translateY(-1px);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--neutral-600);\n  border: 1px solid var(--neutral-300);\n}\n\n.btn-ghost:hover {\n  background: var(--neutral-100);\n  color: var(--neutral-800);\n}\n\n.btn-lg {\n  padding: var(--space-4) var(--space-8);\n  font-size: var(--text-lg);\n  min-height: 56px;\n}\n\n.btn-sm {\n  padding: var(--space-2) var(--space-4);\n  font-size: var(--text-sm);\n  min-height: 40px;\n}\n\n/* Enhanced Form Styles */\n/* Form Groups - Now using global styles from design-system.css */\n\n.form-input::placeholder {\n  color: var(--neutral-400);\n}\n\n/* Enhanced Alert Styles */\n.alert {\n  padding: var(--space-4);\n  border-radius: var(--radius-lg);\n  border: 1px solid;\n  margin-bottom: var(--space-4);\n  font-size: var(--text-base);\n  font-weight: var(--font-medium);\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.alert-success {\n  background: var(--success-50);\n  border-color: var(--success-200);\n  color: var(--success-800);\n}\n\n.alert-warning {\n  background: var(--warning-50);\n  border-color: var(--warning-200);\n  color: var(--warning-800);\n}\n\n.alert-error {\n  background: var(--error-50);\n  border-color: var(--error-200);\n  color: var(--error-800);\n}\n\n.alert-info {\n  background: var(--info-50);\n  border-color: var(--info-200);\n  color: var(--info-800);\n}\n\n/* Enhanced Badge Styles */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--space-1) var(--space-3);\n  font-size: var(--text-sm);\n  font-weight: var(--font-medium);\n  border-radius: var(--radius-full);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.badge-primary {\n  background: var(--primary-100);\n  color: var(--primary-800);\n}\n\n.badge-secondary {\n  background: var(--secondary-100);\n  color: var(--secondary-800);\n}\n\n.badge-success {\n  background: var(--success-100);\n  color: var(--success-800);\n}\n\n.badge-warning {\n  background: var(--warning-100);\n  color: var(--warning-800);\n}\n\n.badge-error {\n  background: var(--error-100);\n  color: var(--error-800);\n}\n\n/* Enhanced Animation Classes */\n.fade-in {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.slide-up {\n  animation: slideUp 0.5s ease-out;\n}\n\n.scale-in {\n  animation: scaleIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsive Grid System */\n.grid {\n  display: grid;\n  gap: var(--space-6);\n}\n\n.grid-cols-1 {\n  grid-template-columns: repeat(1, 1fr);\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n@media (max-width: 768px) {\n\n  .grid-cols-2,\n  .grid-cols-3,\n  .grid-cols-4 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Flexbox Utilities */\n.flex {\n  display: flex;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.gap-2 {\n  gap: var(--space-2);\n}\n\n.gap-4 {\n  gap: var(--space-4);\n}\n\n.gap-6 {\n  gap: var(--space-6);\n}\n\n.gap-8 {\n  gap: var(--space-8);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
